import { Room } from 'outpost';
import { Player } from '../player.ts';
import { FloatingText } from '../animations/floating-text.ts';

export function onPlayerDamage(target: Player, amount: number) {
    Room.update(target, () => target.health -= amount)
        .flash(new FloatingText(target.healthLabel, `-${amount}♥`))
        .waitForAnimation();
}